import __var_0__ from '@stdlib/utils/copy';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var copy = __var_0__;


// MAIN //

/**
* Returns first chart data.
*
* @private
* @returns {(Array|TypedArray)} first stem-and-leaf data
*/
function getX() {
	/* eslint-disable no-invalid-this */
	return copy( this._x );
}


// EXPORTS //
export default getX;
